/* JR "Coming soon" toast -- event-delegated so it works for every
 * [data-jr-coming-soon-msg] trigger on the page (currently the three
 * disabled mega-menu/drawer cards in snippets/header-secondary-nav.liquid),
 * without needing per-instance wiring or a static toast element in markup
 * that would otherwise render twice (desktop header + mobile drawer both
 * include that snippet on every page). Jacob, 2026-09-22.
 */
(function () {
  'use strict';

  var toastEl = null;
  var hideTimer = null;

  function ensureToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'jr-coming-soon-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    document.body.appendChild(toastEl);
    return toastEl;
  }

  function showToast(message) {
    var el = ensureToast();
    el.textContent = message;
    /* restart the fade even on a rapid second click */
    el.classList.remove('is-visible');
    void el.offsetWidth;
    el.classList.add('is-visible');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 2200);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-jr-coming-soon-msg]');
    if (!trigger) return;
    showToast(trigger.getAttribute('data-jr-coming-soon-msg'));
  });
})();
